import { useQuery } from '@tanstack/react-query'
import { handelsregisterCompanySearch } from '../integrations/handelsregister'
import { getApiErrorMessage } from '@utils'
import { useTranslation } from 'react-i18next'

export const useHandelsregisterSearch = (
  searchTerm: string | undefined,
  enabled = true,
  businessSlug?: string
) => {
  const [t] = useTranslation()

  const query = useQuery({
    queryKey: ['handelsregister', 'search', businessSlug, searchTerm?.toLowerCase()],
    queryFn: () =>
      handelsregisterCompanySearch({
        searchTerm: searchTerm?.toLowerCase() ?? '',
        businessSlug
      }),
    enabled: enabled && (searchTerm?.length ?? 0) >= 3,
    retry: 1,
    staleTime: 1000 * 60 * 60 // 60 mins,
  })

  const errorMessage = getApiErrorMessage(query.error, t('general.error'))

  return { query, errorMessage }
}
